import AllClientDetails from './AllClientDetails';

export default AllClientDetails;


// WEBPACK FOOTER //
// ./src/features/reports/components/single-client-details/all-client-details/index.js